export function normalizeSkuPart(value) {
    return String(value ?? "")
        .trim()
        .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function buildImageAltValue(skuValue, imageIndex) {
    const normalizedSku = normalizeSkuPart(skuValue).replace(/^-+|-+$/g, "");
    const baseValue = normalizedSku || "variant-image";
    return `${baseValue}-${imageIndex}`;
}

export function stripFileExtension(fileName) {
    const normalizedName = String(fileName || "").trim();
    if (!normalizedName) {
        return "";
    }

    const lastDotIndex = normalizedName.lastIndexOf(".");
    if (lastDotIndex <= 0) {
        return normalizedName;
    }

    return normalizedName.slice(0, lastDotIndex);
}

export function buildDefaultImageLabel(file, fallbackSkuValue, imageIndex) {
    const fileNameWithoutExtension = stripFileExtension(file?.name);
    if (fileNameWithoutExtension) {
        return fileNameWithoutExtension;
    }

    return buildImageAltValue(fallbackSkuValue, imageIndex);
}

export function createLocalImagePreview(file) {
    if (!(file instanceof File)) {
        return null;
    }

    const localPreviewId = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `local-image-${file.name}-${file.lastModified}-${file.size}`;

    return {
        id: localPreviewId,
        url: URL.createObjectURL(file),
        source: "local",
        file,
    };
}

export function extractImageUrl(image) {
    if (!image) {
        return "";
    }

    if (typeof image === "string") {
        return image.trim();
    }

    return String(
        image?.URL
        || image?.url
        || image?.Src
        || image?.src
        || image?.ImageURL
        || image?.image_url
        || ""
    ).trim();
}

export function readFileAsDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(String(reader.result || ""));
        };
        reader.onerror = () => {
            reject(new Error(`Failed to read image file: ${file?.name || "unknown file"}`));
        };
        reader.readAsDataURL(file);
    });
}
